import React, {Component} from 'react';
import BanerHome from '../components/layout/BanerHome';
import CardExample from '../components/layout/CardExample';
import BlogPage from '../components/layout/BlogPage';
import PersonList from '../components/layout/PersonList';
import Haloffame from '../components/layout/Haloffame';

export default class landing extends Component {
  style = {
    fontSize: 20
  };

  render() {
    return (
      <div className='lan'>
        <BanerHome />
        <div className='main'>
          <p style={this.style}>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam
            aperiam iste natus voluptatum! Cupiditate, voluptatum qui ratione
            ipsum quisquam suscipit molestias, rem enim eveniet recusandae cum
            blanditiis est animi at illo ullam optio adipisci? Sint magnam
            veniam at. Nulla placeat necessitatibus neque commodi. Saepe totam
            ullam libero aspernatur amet cum ab non reprehenderit qui veritatis
            odit debitis facere, praesentium perferendis fugit impedit tempora
            ut ex consequuntur accusamus officiis nisi voluptatibus. Numquam
            ullam voluptate sed, necessitatibus beatae ut recusandae rem
            reprehenderit cum quis fuga! Eaque quo possimus aut aspernatur
            dignissimos, dolorum officia saepe dolor eius odit doloribus
            necessitatibus voluptates animi modi.
          </p>
          <br />
        </div>
        <div className='cardMain'>
          <CardExample />
        </div>
        <br />
        <br />
        <div className='main'>
          <h2 className='tekst1'>Workers</h2>
          <br />
          <PersonList />
        </div>
        <BlogPage />
        <br />
        <br />
        <div className='main'>
          <p style={this.style}>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam
            aperiam iste natus voluptatum! Cupiditate, voluptatum qui ratione
            ipsum quisquam suscipit molestias, rem enim eveniet recusandae cum
            blanditiis est animi at illo ullam optio adipisci? Sint magnam
          </p>
        </div>
        <br />
        <br />
        <div className='carousel'>
          <h2 className='tekst1'>Hal of Fame</h2>
          {/* <Carousel /> */}
          <Haloffame />
        </div>
      </div>
    );
  }
}
